module.exports = __webpack_public_path__ + "static/media/calendarIcon.8de447e8.svg";